module.exports = __webpack_public_path__ + "static/media/fabiano-gregorio.2698d379.jpg";